import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCol,
  MDBRow,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBTextArea
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getSpecificUserGroup, updateGroupUser } from "../apiclients/streamsapi_bridge";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import SaveChanges from "../components/topviews/saveCancel";
import UsersGroup from "./UsersGroup";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
function SelectedUserGroupSettings(props) {
  const location = useLocation();
  const actTab = location.state ? location.state.tab ? location.state.tab : "tab1" : "tab1";
  const [basicActive, setBasicActive] = useState(actTab);
  const navigate = useNavigate();
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }

    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    // reset();
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#")
      if (targetValues.length > 2) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1], tab2: targetValues[2] },
          }
        );

      } else if (targetValues.length > 1) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1] },
          }
        );

      }
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  const [verticalActive, setVerticalActive] = useState("tab1");

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [AddUsers, setAddUsers] = useState(false);
  const toggleShow13 = () => setAddUsers(!AddUsers);
  // const [successMessage, setSuccessMessage] = useState("");
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [userGroupInfo, setUserGroupInfo] = useState(
    location?.state?.groupUInfo ? location?.state?.groupUInfo : location.state ? location.state : {}
  );

  const { register, formState: { isDirty, errors, dirtyFields }, watch, reset, setError, clearErrors, handleSubmit, setValue } = useForm({
    defaultValues: {
      name: "",
      description: "",
    }
  });

  // const groupIds = location.state ? location.state.tab ? location.state.groupids : userGroupInfo.usergroup_id : userGroupInfo.usergroup_id;
  // const [usergroupid, setusergroupid] = useState(groupIds)


  // useEffect(() => {
  //   if (successMessage) {
  //     setTimeout(() => {
  //       setSuccessMessage(""); // Clear the success message in the parent component
  //     }, 5000);
  //   }
  // }, [successMessage]);

  function closeSave(e) {
    reset();
  }


  console.log("User Group Info :::::::::: " + JSON.stringify(userGroupInfo));

  useEffect(() => {
    if (userGroupInfo.usergroup_id || rerender) {
      fetchSpecificUserGroupInfo();
      setRerender(false);
    }

  }, [userGroupInfo.usergroup_id, rerender]);

  async function fetchSpecificUserGroupInfo() {

    try {
      // setIsloading(true);
      const response = await getSpecificUserGroup(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        userGroupInfo.usergroup_id
      );
      // setTimeout(() => {
      //   setIsloading(false);
      // }, 1000);
      const groupDetails = await response.json();
      console.log("getSpecific userGroup ::: " + JSON.stringify(groupDetails));
      const userGroupDetails = {
        name: groupDetails?.usergroups?.usergroup_name ?? "",
        description: groupDetails?.usergroups?.description ?? "",
      }
      reset(userGroupDetails);

      setRerender(false);

    } catch (error) {

    }

  }


  const isSave =
    Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave)

  }, [isSave])

  const onSubmit = async (data) => {
    const modifiedData = {};
    for (const field of Object.keys(dirtyFields)) {
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        modifiedData[field] = data[field];
      }

    }

    let update = {}
    if (modifiedData) {

      modifiedData.reqid = 76;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.usergroup_id = userGroupInfo.usergroup_id;
    }

    console.log("modified data for phone edit :::" + JSON.stringify(modifiedData));
    console.log(JSON.stringify(modifiedData));
    setIsloading(true);
    let saverep = await updateGroupUser(modifiedData);
    console.log(`reponse of phone edit :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified data :::" + JSON.stringify(saverepeMsg)
    );
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      setRerender(true);
      localStorage.setItem("s_message", saverepeMsg.message);
      // setSuccessMessage(saverepeMsg.message);
    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {

          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
            fieldElement.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    }


  }



  return (
    <React.Fragment>
      <>
        <MainLinks active={3} />
        <Body
          tablinks={3}
          sublink={8}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/userlanding#suser#suser");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/userlanding", {
                              state: { tab: "suser", tab2: "suser" },
                            });
                          }}>
                            <strong>{t("users")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/userlanding#mgroups");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/userlanding", {
                              state: { tab: "mgroups" },
                            });
                          }}>
                            <strong>{t("UsersGroup")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem >
                          <a href="">
                            <strong>{watch("name")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">

                    <div className="">
                      <h5 className="fw-600 ">{watch("name")}</h5>
                      <p className=" my-2 text-secondary">{watch("description")}</p>
                    </div>
                    <MDBTabs className="mt-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          {t("users")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent className="mt-3">
                      <MDBTabsPane open={basicActive === "tab1"}>
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBTabs className="flex-column">
                              <MDBTabsItem>
                                <MDBTabsLink
                                  onClick={() => handleVerticalClick("tab1")}
                                  active={verticalActive === "tab1"}
                                >
                                  {t("general")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                            </MDBTabs>
                          </MDBCol>
                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <MDBTabsContent>
                              <MDBTabsPane open={verticalActive === "tab1"}>
                                <MDBCol size="10" className="pr-0">
                                  <div className="vtabHeight pt-0">
                                    <div className="w-9">
                                      <div className="general-settings">
                                        {t("general")}
                                      </div>
                                      <div className="ps-3">
                                        <div className="add-numbermain">
                                          <div className="tel-numbers">
                                            {t("name")}
                                          </div>
                                          <div className="phoneselect w-30">
                                            <input
                                              type="text"
                                              {...register("name", { required: "Name is required" })}
                                              className="selectname w-100"
                                            />
                                            {errors.name && (
                                              <p className="text-danger">{errors.name.message}</p>
                                            )}
                                          </div>
                                        </div>

                                        <div className="add-numbermain">
                                          <div className="tel-numbers">
                                            {t("Description")}
                                          </div>
                                          <div className="phoneselect w-50">
                                            <div className="form pt-1 w-100">
                                              <MDBTextArea
                                                id="textAreaExample"
                                                className="w-100"
                                                rows={2}
                                                {...register("description", { required: "Description is required" })}
                                                value={watch("description")}
                                                onChange={(e) => {
                                                  clearErrors("description");
                                                  setValue("description", e.target.value, { shouldDirty: true });
                                                }
                                                }
                                              />
                                              {errors.description && (
                                                <p className="text-danger">{errors.description.message}</p>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </MDBCol>
                                {/* <div className="btnControls">
                                  <a
                                    className="ripple ripple-surface btn btn-secondary"
                                    role="button"
                                  >
                                    {t("close")}
                                  </a>
                                  <button
                                    className="ripple ripple-surface btn btn-primary btn btn-primary ml-3"
                                    role="button"
                                  >
                                    {t("saveChanges")}
                                  </button>
                                </div> */}
                                {isSave && (
                                  <SaveChanges
                                    onClose={closeSave}
                                    isdirtyFields={isSave}
                                    onSave={(e) => {
                                      e.preventDefault();
                                      handleSubmit(onSubmit)();
                                    }}
                                  />
                                )}
                              </MDBTabsPane>
                            </MDBTabsContent>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>

                      <MDBTabsPane open={basicActive === "tab2"}>
                        <UsersGroup groupInfo={userGroupInfo} basicActive={basicActive === 'tab2'} />


                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>

                </div>
              </section>
              {isloading && (
                <>
                  <div className="loadingclass">
                    <MDBBtn disabled>
                      <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                      Loading...
                    </MDBBtn>
                  </div>
                </>
              )}
            </>
          }
        />
        {/* <Footer /> */}
        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
      </>
    </React.Fragment>
  );
}

export default SelectedUserGroupSettings;
